export const hoverLightBlueShadedColumn = (params: any) => {
  return params.api.getAllDisplayedColumns().some(
    col => col.colDef.cellClass === 'shaded-cell-light-blue-5',
  );
};
